export default "__VITE_ASSET__12EQMMop__"